import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';

const Layout = () => {
  return (
    <PXFormModalWrapper>
      <MetaControlField attr="description" />
      <MetaControlField attr="corrections" />
    </PXFormModalWrapper>
  );
};

export default Layout;
